<template>
    <div class="form-sales-project form-sales-land" v-if="form != null && setup != null">
        <div class="container">
            <div class="form-in-container">
                <div class="form-sales-title">
                    <h2>{{form.form_sales_land_title}}</h2>
                    <h4>{{form.form_sales_land_desc}}</h4>
                </div>
                <div class="form-sales-items" v-if="currentPhone != null">
                    <div class="item">
                        <div class="item-icon">
                            <svg-icon icon-class="phone_promo" className="icon-phone"/>
                        </div>
                        <div class="item-in">
                            <p>Офис продаж<span> в {{correctEndOfRussianWords(currentPhone.region)}}</span></p>
                            <a :href="'tel:' + currentPhone.region_phone">{{currentPhone.region_phone}}</a>
                        </div>
                    </div>
                </div>
                <form class="form_call">
                    <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                        <div class="form-group form-text">
                            <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                        </div>
                        <div class="form-group form-phone">
                            <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000" v-if="projectHost != 'kohota'"/>
                            <masked-input v-model="phone" mask="\+\998 (11) 111-11-11" placeholder="+998" class="form-control" name="phone" v-validate="{ required: true }" data-vv-delay="1000" v-if="projectHost == 'kohota'"/>
                        </div>
                        <VueRecaptcha
                            ref="recaptchaFormPage"
                            @verify="onCaptchaVerified"
                            :sitekey="salesGcap_siteKey"
                            size="invisible"
                        />
                        <div class="btn-send">
                            <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.form_sales_promo_btn}}</button>
                            <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email')">Заполните все поля</span>\
                        </div>
                    </div>
                    <div class="successMessage" v-if="!formVisible">
                        <h3>Спасибо! Ваша заявка отправлена.</h3>
                    </div>
                </form>
            </div>
            <div class="privacy-desc" v-if="formVisible">
                <p>
                    <span>{{ salesCard.shablon_form_privacy_desc.one }}</span> 
                    «<span>{{ form.form_sales_promo_btn }}</span>» <br>
                    <span class="two">{{ salesCard.shablon_form_privacy_desc.two }}</span>
                    <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ salesCard.shablon_form_privacy_desc.word }}</a></span>
                    <span class="three">{{ salesCard.shablon_form_privacy_desc.three }}</span>
                </p>
            </div>
            <div class="to-many-requests-msg" v-if="toManySendingMsg">
                <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    import { VueRecaptcha } from 'vue-recaptcha';
    const dict = {
        custom: {
            name: {
                required: () => 'Введите ваше имя'
            },
            phone: {
                required: () => 'Введите ваш номер телефона'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'FormConsultLand',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                quest: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                currentPhone: null,
                projectHost: window.host,
                lang: window.GlobalLang,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            form: 'loadForms',
            salesCard: 'loadSalesCardContent',
            saleItem: 'loadSaleCardItem',
            setup: 'loadPageSetUp',
            currentCity: 'loadCurCity',
            // openFormConsult: 'loadOpenFormConsult',
            formData: 'loadFormConsultData',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            correctEndOfRussianWords(word) {
                if (this.lang != 'kz/') {
                    if (word == 'Астана') {
                        return 'Астане';
                    } else {
                        return word;
                    }
                } else {
                    return word;
                }
            },
            filterPhoneCity() {
                if (this.setup != null && this.currentCity != null) {
                    var data = this.setup.regions_name;
                    var filteredItems = data.filter(item => {
                        return item.region_lat.slug == this.currentCity.slug;
                    });
                    // console.log(filteredItems, 'CURRENT PHONE FORM');
                    if (filteredItems.length > 0) {
                        this.currentPhone = filteredItems[0];
                    } else  {
                        // console.log('length error filtered cityes header');
                        this.currentPhone = '+7(727) 2 777-777';
                    } 
                }
            },
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('shablonformPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('shablonformPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'name': this.name,
                    'phone': this.phone,
                    'project' : this.saleItem.project_name.slug,
                    'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                };
                if (window.host == 'qazyna') {
                    data.project = this.saleItem.project_name.slug.charAt(0).toUpperCase() + this.saleItem.project_name.slug.slice(1);
                }
                this.formVisible = false;
                // console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('shablonformPage_submissionCounter', submissionCounter);
                    localStorage.setItem('shablonformPage_lastSubmissionTime', currentMinutes);
                    dataLayer.push({'event' : 'form_sent'})
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok')
                        this.$refs.recaptchaFormPage.execute();
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            sendInGoogleDoc(project) {
                // console.log(project)
                if (project == 'orion') {
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSdxDpid76ukWEsdSH8NHunJLMSM4WcKTQeu7X_ljtEwlTE3Hg/formResponse",
                        data: {
                            // name
                            "entry.706067676": this.name,
                            // phone
                            "entry.1576989596": this.phone,
                            // project
                            "entry.1073377977": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                    setTimeout(() => {
                        this.closeForm();
                    }, 1500);
                } else if (project == 'aqualina') {
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSdwXMur4HxwBrpcpHIA5jLrnnZnWAMilsa5WCUX7qoNMsTbzA/formResponse",
                        data: {
                            // name
                            "entry.794708322": this.name,
                            // phone
                            "entry.815623301": this.phone,
                            // project
                            "entry.1190362914": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                    setTimeout(() => {
                        this.closeForm();
                    }, 1500);
                } else if (project == 'akvarel') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSdib-QUs1yEGDirF2OsXoh-oX3nZ6g2MHcDYUu5aFqW1jnHIQ/formResponse",
                        data: {
                            // name
                            "entry.1868024718": this.name,
                            // phone
                            "entry.188399809": this.phone,
                            // project
                            "entry.2065049446": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                    setTimeout(() => {
                        this.closeForm();
                    }, 1500);
                } else if (project == 'jazzkvartal') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSeFTRidWiKYOz_0QLMNFzkZMGzCMPIZMkmnLGc-ZYIFqx4YFg/formResponse",
                        data: {
                            // name
                            "entry.666256778": this.name,
                            // phone
                            "entry.958004545": this.phone,
                            // project
                            "entry.513109114": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                } else if (project == 'austria') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSfrRbeW89UP9QUqnqmo63D_PBnYmhYTpkk1xq_yDpsoRR86jQ/formResponse",
                        data: {
                            // name
                            "entry.1554562960": this.name,
                            // phone
                            "entry.846535864": this.phone,
                            // project
                            "entry.1622687264": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                } else if (project == 'auezovcity') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSfS5_61uWPjAfBIwidoSHzT7PXZLxKjBZPlbFZWSJFBWvR6Gw/formResponse",
                        data: {
                            // name
                            "entry.738830245": this.name,
                            // phone
                            "entry.1716609044": this.phone,
                            // project
                            "entry.82677976": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                } else if (project == 'shahristan') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSe-xv57RqOBS1W4NYttUbJPvkRBPA_SQL6owK4DXfy_och-HQ/formResponse",
                        data: {
                            // name
                            "entry.1343526366": this.name,
                            // phone
                            "entry.225756219": this.phone,
                            // project
                            "entry.819824187": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                } else if (project == 'primavera') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSeKX9AmMQJNUXZROuDFGtOzCoVyvRx5jUT3ljRWp8ty0DFp7w/formResponse",
                        data: {
                            // name
                            "entry.1856183452": this.name,
                            // phone
                            "entry.1694245124": this.phone,
                            // project
                            "entry.2078246579": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                } else if (project == 'yassy-tower') { 
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLScxzxFL78m31NkhaE1bRqvSZS8oEhKOR09SeCujiyKEsT-Tlw/formResponse",
                        data: {
                            // name
                            "entry.1311460915": this.name,
                            // phone
                            "entry.119847274": this.phone,
                            // project
                            "entry.1677905732": project,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                } else {
                    console.log('error with project name');
                    return false;
                }
            },
            closeForm() {
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                this.phone = '';
                this.name = '';
                setTimeout(() => {
                    this.formVisible = true;
                }, 1000);
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
            this.filterPhoneCity();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue != null) {
                        this.changeLang();
                        this.filterPhoneCity();
                    }
                }
            );
            this.$store.watch(
                (state) => state.currentCity,
                (newValue) => {
                    this.filterPhoneCity();
                }
            );
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-sales-land.scss';
    @import '@/styles/respond/forms/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-consult-respond.scss';
</style>